import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export const helpContent: ISidebarHelp = {
	title: 'Metas',
	firstParagraph:
		'Nesta tela é possível cadastrar e visualizar Metas de Produção dos grupos de recursos da sua indústria. A meta ideal, global, para a eficiência dos recursos é de 85%. Porém, a eficiência dos recursos pode variar de acordo com o mix de produtos, número de setups realizados, entre outros. Por isso, é importante levar em consideração todas as situações de cada grupo de recurso para definir sua meta.',
	secondParagraph:
		'Para cadastrar uma meta, nos filtros selecione o Ano e Mês em que deseja entrar com a nova meta, em seguida clique em cima do nome do Grupo de Recurso e entre com os valores de disponibilidade, performance e qualidade. IROG = disponibilidade x performance x qualidade. Ao clicar em "Salvar", será permitido salvar a meta criada para o ano inteiro ou apenas para o mês selecionado.',
	firstLink: URL_CT360,
	secondLink: URL_FALE_CONOSCO,
};
